module.exports = __webpack_public_path__ + "media/images/logo/Logo(H)_Light-2561472b97a1208dcc1923a30a940a71.png";